import React, { Component } from "react";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";

import Button from "@material-ui/core/Button";
import Divider from "@material-ui/core/Divider";
import Fab from "@material-ui/core/Fab";
import FormControl from "@material-ui/core/FormControl";
import IconButton from "@material-ui/core/IconButton";
import LinearProgress from "@material-ui/core/LinearProgress";
import MenuItem from "@material-ui/core/MenuItem";
import OutlinedInput from "@material-ui/core/OutlinedInput";
import Paper from "@material-ui/core/Paper";
import Select from "@material-ui/core/Select";
import Table from "@material-ui/core/Table";
import TableBody from "@material-ui/core/TableBody";
import TableCell from "@material-ui/core/TableCell";
import TableHead from "@material-ui/core/TableHead";
import TableRow from "@material-ui/core/TableRow";
import TableSortLabel from "@material-ui/core/TableSortLabel";
import Toolbar from "@material-ui/core/Toolbar";
import Tooltip from "@material-ui/core/Tooltip";
import Typography from "@material-ui/core/Typography";

import AddIcon from "@material-ui/icons/Add";
import EditIcon from "@material-ui/icons/Edit";
import RefreshIcon from "@material-ui/icons/Refresh";

import AdminWrapper from "../../containers/AdminWrapper";
import ContentWrapper from "../../containers/ContentWrapper";

//actions
import * as shootActions from "../../redux/actions/shootsactions";
import * as dialogActions from "../../redux/actions/dialogactions";
import Checkbox from "@material-ui/core/Checkbox";
//Services
import questionService from "../../services/questionService";

class AddShootQuestion extends Component {
  constructor(props) {
    super(props);
    this.state = {
      fetching: true,
      failed: false,
      data: [],
      open: false,
      selectedMenu: null,
      selectedQuestion: {},
      orderBy: "position",
      order: "asc",
      filterstate: ""
    };
  }
  componentDidMount() {}

  goToCreateQuestion = () => this.props.history.push("/questions/add");

  createSortHandler = property => {
    // console.log("sort", property);
    this.handleRequestSort(property);
  };
  handleRequestSort = property => {
    const isDesc = this.state.orderBy === property && this.state.order === "desc";
    this.setState({ order: isDesc ? "asc" : "desc" });
    this.setState({ orderBy: property });
  };

  stableSort = (array, cmp) => {
    // console.log("data", array);
    const stabilizedThis = array.map((el, index) => [el, index]);
    stabilizedThis.sort((a, b) => {
      const order = cmp(a[0], b[0]);
      if (order !== 0) return order;
      return a[1] - b[1];
    });
    return stabilizedThis.map(el => el[0]);
  };

  getSorting = (order, orderBy) => {
    return order === "desc" ? (a, b) => this.desc(a, b, orderBy) : (a, b) => -this.desc(a, b, orderBy);
  };

  desc = (a, b, orderBy) => {
    if (b[orderBy] < a[orderBy]) {
      return -1;
    }
    if (b[orderBy] > a[orderBy]) {
      return 1;
    }
    return 0;
  };
  handleChangeFilter = e => {
    // console.log("filter", e.target.value);
    // this.setState({
    //   filterstate: e.target.value
    // });
    this.props.changeSelectedFilter(e.target.value);
  };

  handleCheckboxChange = index => {
    this.props.handleSelectQuestion(index);
  };

  handleSelectAll = () => {
    this.props.handleSelectedAll();
  };

  render() {
    const open = this.state.open;
    const { orderBy, order, data, filterstate } = this.state;
    let { questions, type, selectedQuestions } = this.props;
    // console.log("rendwer", questions);
    let queryData = this.stableSort(questions, this.getSorting(order, orderBy));
    console.log(queryData);
    let filteredData = queryData;
    if (this.props.type !== "VIEW") filteredData = queryData.filter(e => e.position.includes(this.props.selectedFilter));
    const sessionList = filteredData.map((session, key) => {
      let { selectedQuestions, type } = this.props;
      let selected;
      if (type !== "VIEW") {
        selected = selectedQuestions.includes(session.id);
      }
      return (
        <TableRow key={session.id}>
          {type !== "VIEW" && (
            <TableCell padding="checkbox">
              <Checkbox
                color="primary"
                checked={selected}
                onChange={() => this.handleCheckboxChange(session.id)}
                // inputProps={{ 'aria-labelledby': labelId }}
              />
            </TableCell>
          )}
          <TableCell>{session.position}</TableCell>
          <TableCell>{session.question}</TableCell>
        </TableRow>
      );
    });

    const headRows = [
      { id: "position", numeric: false, disablePadding: false, label: "Position" },
      { id: "", numeric: false, disablePadding: false, label: "Question" }
    ];
    return (
      <Paper
        style={{
          width: 800,
          margin: "20px auto"
        }}
      >
        <Toolbar>
          <Typography variant="subtitle2">{this.props.title}</Typography>
          <div style={{ flexGrow: 1 }} />
          {this.props.type !== "VIEW" && (
            <>
              <Typography variant="body2" style={{ marginRight: 8 }} color="textSecondary">
                Filter Role:
              </Typography>
              <FormControl variant="outlined" style={{ marginRight: 10 }}>
                <Select
                  value={this.props.selectedFilter}
                  onChange={this.handleChangeFilter}
                  displayEmpty={true}
                  input={<OutlinedInput name="filter" margin="dense" placeholder="Filter" labelWidth={0} />}
                >
                  <MenuItem value="">
                    <em>None</em>
                  </MenuItem>
                  {this.props.positions.map(item => {
                    return (
                      <MenuItem key={item} value={item}>
                        {item}
                      </MenuItem>
                    );
                  })}
                  {/* <MenuItem value="Hygienist">Hygienist</MenuItem>
              <MenuItem value="Frontdesk">Frontdesk</MenuItem> */}
                </Select>
              </FormControl>
            </>
          )}
        </Toolbar>
        <Divider />
        {this.props.fetching ? <LinearProgress color="primary" style={{ height: 2 }} /> : null}
        {this.props.failed ? (
          <div style={{ padding: "20px 0", textAlign: "center" }}>
            <Typography variant="h3" gutterBottom style={{ color: "rgba(0,0,0,0.5)" }}>
              Something went wrong...
            </Typography>
            <Button variant="outlined" color="primary" onClick={this.getShoots}>
              Reload
            </Button>
          </div>
        ) : (
          <Table>
            <TableHead>
              <TableRow>
                {type !== "VIEW" && (
                  <TableCell padding="checkbox">
                    <Checkbox
                      indeterminate={selectedQuestions.length > 0 && selectedQuestions.length < filteredData.length}
                      checked={filteredData.length > 0 ? selectedQuestions.length === filteredData.length : false}
                      onChange={this.handleSelectAll}
                      inputProps={{ "aria-label": "select all desserts" }}
                    />
                  </TableCell>
                )}
                {headRows.map((row, key) => (
                  <TableCell
                    key={key}
                    align={row.numeric ? "right" : "left"}
                    padding={row.disablePadding ? "none" : "default"}
                    sortDirection={orderBy === row.id ? order : false}
                    onClick={row.id == "" ? null : () => this.createSortHandler(row.id)}
                    style={row.id == "" ? null : { cursor: "pointer" }}
                  >
                    {this.state.orderBy === row.id ? (
                      <TableSortLabel active={orderBy === row.id} direction={order}>
                        {row.label}
                      </TableSortLabel>
                    ) : (
                      row.label
                    )}
                  </TableCell>
                ))}
              </TableRow>
            </TableHead>
            <TableBody>{sessionList}</TableBody>
          </Table>
        )}
      </Paper>
    );
  }
}

const mapStateToProps = state => {
  return {
    confirmDialog: state.dialog.confirm.open,
    confirmAction: state.dialog.confirm.action,
    confirmChoice: state.dialog.confirm.confirmed
  };
};

const mapDispatchToProps = dispatch => {
  return {
    dialogActions: bindActionCreators(dialogActions, dispatch),
    shootActions: bindActionCreators(shootActions, dispatch)
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(AddShootQuestion);
